<template> <!-- OK -->
  <div class="login-container">
    <div class="login-image">
      <img src="../assets/logo_tennisRank_login.png" alt="Tennis Court">
    </div>
    <div class="login-card">
      <Login/>
    </div>
  </div>
</template>


<script>

import Login from '../components/Login.vue';

export default {
  name: 'LoginView',
  components: {
    Login
  }
}

</script>


<style scoped>


.login-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: linear-gradient(0deg, #3a67bf, #020094),
              linear-gradient(90deg, #3a67bf, #020094),
              linear-gradient(135deg, #3a67bf, #020094);

}

.login-image {
  width: 20vw;
  height: 20vw;
}

.login-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  align-items: center;
  justify-content: center;
}

@media (max-width: 450px) {
  .login-container {
    flex-direction: column;
    padding: 1rem;
  }

  .login-image {
    width: 40vw;
    height: 40vw;
  }

  .login-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    align-items: center;
    justify-content: center;
  }
}

@media (min-width: 769px) {

  .login-image {
    width: 20vw;
    height: 20vw;
  }

  .login-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    align-items: center;
    justify-content: center;
  }

}


</style>